import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useQuotationPermissions() {
  const quotationActivationState = useSelector(
    (store: AppState) => store.auth.selectedCompany.quotationActivationState
  );

  const { hasRelations, getIsAuditor } = useCheckRelations();

  const canViewQuotations =
    quotationActivationState === WintSuperkollAPIModel.QuotationActivationState.Activated &&
    hasRelations([
      AuthEnums.PersonCompanyRelationType.InvoicesAdmin,
      AuthEnums.PersonCompanyRelationType.Invoices,
      AuthEnums.PersonCompanyRelationType.Admin,
    ]);

  const canCreateQuotations = canViewQuotations && !getIsAuditor();

  return { canViewQuotations, canCreateQuotations };
}

export default useQuotationPermissions;
